import type { SupportedLanguages } from 'constants/translations/_types';

import type { LanguageDto } from '../types';

export const parseLanguageForBE = (languageCode: SupportedLanguages): LanguageDto => ({
  language: languageCode,
});
